<template>
  <div class="products-inventory-modern">
    <!-- Modals -->
    <b-modal
      id="provider_code"
      :title="product ? product.name : ''"
      size="lg"
      hide-footer
      no-close-on-backdrop
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-code mr-2"></i>
          Códigos do Fornecedor
        </div>
      </template>
      <div class="modal-content-wrapper">
        <h3 class="modal-subtitle">
          Códigos do produto com fornecedor utilizados na nota fiscal
        </h3>
        <ProviderCode
          type="product"
          :stock_item_id="product ? product.id : null"
        />
      </div>
    </b-modal>

    <b-modal
      id="new_product"
      size="lg"
      hide-footer
      no-close-on-backdrop
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-plus mr-2"></i>
          Novo Produto
        </div>
      </template>
      <new-product
        :stock_item_categories="stock_item_categories"
        :stock_item_units_of_measurement="stock_item_units_of_measurement"
        :product_units_of_measurement="units_of_measurement"
        @created="getProducts"
      />
    </b-modal>

    <b-modal
      id="view_product"
      size="lg"
      hide-footer
      no-close-on-backdrop
      @hide="product = null"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-edit mr-2"></i>
          Editar Produto
        </div>
      </template>
      <view-product
        :product="product"
        :categories="stock_item_categories"
        :unitsOfMeasurement="stock_item_units_of_measurement"
        :finance_configuration_category="finance_configuration_category"
        @updated="closeModalViewProduct"
        @get_finance_configuration_category="
          $emit('get_finance_configuration_category')
        "
      />
    </b-modal>

    <!-- Main Content -->
    <div class="products-content">
      <!-- Header Section -->
      <div class="content-header">
        <div class="header-left">
          <h2 class="section-title">
            <i class="fas fa-boxes section-icon"></i>
            Produtos
          </h2>
          <p class="section-subtitle">
            Gerencie e monitore todos os produtos da instituição
          </p>
        </div>
        <div class="header-actions">
          <v-btn
            v-if="permission('write', 'product')"
            @click="$bvModal.show('new_product')"
            class="btn-add-modern"
          >
            <i class="fas fa-plus mr-2"></i>
            Novo Produto
          </v-btn>
        </div>
      </div>

      <!-- Filters Section -->
      <div class="filters-section">
        <div class="filters-card">
          <div class="filters-header">
            <h3 class="filters-title">
              <i class="fas fa-filter mr-2"></i>
              Filtros de Pesquisa
            </h3>
          </div>
          <div class="filters-grid">
            <!-- Buscar -->
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-search filter-icon"></i>
                Buscar
              </label>
              <b-input
                v-model="search"
                @input="handleSearch"
                placeholder="Digite o nome do produto"
                class="modern-input"
              />
            </div>

            <!-- Categoria -->
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-tags filter-icon"></i>
                Categoria
              </label>
              <b-form-select
                v-model="stock_item_category_id"
                class="modern-select"
              >
                <b-form-select-option value="">
                  Todas as Categorias
                </b-form-select-option>
                <b-form-select-option
                  v-for="category in stock_item_categories"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.name }}
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Table Section -->
      <div class="table-section">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <!-- No Results -->
          <div v-show="products.length == 0" class="no-results">
            <i class="fas fa-search no-results-icon"></i>
            <h3 class="no-results-title">Nenhum produto encontrado</h3>
            <p class="no-results-text">
              Tente ajustar os filtros para encontrar resultados
            </p>
          </div>

          <!-- Data Table -->
          <div v-show="products.length > 0" class="table-card">
            <v-data-table
              dense
              :items="products"
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [25, 50, 75, 100],
                'items-per-page-text': 'Mostrar',
              }"
              :options.sync="options"
              :server-items-length="total"
              class="modern-table"
              :no-data-text="'Nenhum produto encontrado'"
              :loading-text="'Carregando produtos...'"
            >
              <template #[`item.name`]="{ item }">
                <div class="product-name-cell">
                  <div class="product-name">{{ item.name }}</div>
                </div>
              </template>

              <template #[`item.category.name`]="{ item }">
                <div class="category-cell">
                  <span v-if="item.category" class="category-badge">
                    <i class="fas fa-tag mr-1"></i>
                    {{ item.category.name }}
                  </span>
                  <span v-else class="no-category">Sem categoria</span>
                </div>
              </template>

              <template #[`item.actions`]="{ item }">
                <div class="actions-cell">
                  <v-btn
                    small
                    class="btn-action-code"
                    @click="openModalProviderCode(item)"
                  >
                    <i class="fas fa-code mr-1"></i>
                    Fornecedor
                  </v-btn>
                  <v-btn
                    v-if="permission('edit', 'product')"
                    small
                    class="btn-action-edit"
                    @click="openModalViewProduct(item)"
                  >
                    <i class="fas fa-edit mr-1"></i>
                    Editar
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </div>
        </b-overlay>
      </div>

      <!-- Error Messages -->
      <ErrorsMessages :errors="errors" v-if="errors.length > 0" />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import NewProduct from "../products/new-product.vue";
import ViewProduct from "../products/view-product.vue";

import ProviderCode from "../../../provider-code/view";

import api from "../../../../services/api";

import permission from "../../../../lib/permission";

export default {
  name: "Products",

  components: {
    ErrorsMessages,
    NewProduct,
    ViewProduct,
    ProviderCode,
  },

  props: {
    finance_configuration_category: Array,
  },

  data() {
    return {
      total: 0,
      options: {},

      errors: [],
      loading: false,

      search: "",
      headers: [
        { text: "NOME", value: "name" },
        { text: "CATEGORIA", value: "category.name" },
        { text: "AÇÕES", value: "actions", width: "auto", sortable: false },
      ],
      raw_products: [],

      product: null,
      stock_item_category_id: "",

      categories: [],
      units_of_measurement: [],
      stock_item_categories: [],
      stock_item_units_of_measurement: [],
      category: null,
    };
  },

  watch: {
    options: {
      handler() {
        this.getProducts();
      },
    },
  },

  computed: {
    products() {
      let base = this.raw_products;

      if (this.stock_item_category_id)
        base = base.filter(
          (category) =>
            category.stock_item_category_id === this.stock_item_category_id
        );

      return base.map((product) => ({
        ...product,
        category: this.stock_item_categories.find(
          (item) => item.id === product.stock_item_category_id
        ),
      }));
    },
  },

  async created() {
    await this.getCategories();
    await this.getUnitsOfMeasurement();
    await this.getProductUnitsOfMeasurement();
  },

  methods: {
    permission,

    handleSearch() {
      this.options.page = 1;
      this.getProducts();
    },

    openModalProviderCode(product) {
      this.product = product;
      this.$bvModal.show("provider_code");
    },

    openModalViewProduct(product) {
      this.product = product;
      this.$bvModal.show("view_product");
    },

    closeModalViewProduct() {
      this.product = null;
      this.getProducts();
    },

    async getProducts() {
      try {
        this.loading = true;

        const { stock_item_category_id, search } = this;

        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        const params = {
          stock_item_category_id,
          page,
          itemsPerPage,
          search,
          sortBy,
          sortDesc,
        };

        const response = await api.get("/rest-home/stock/items/products", {
          params,
        });

        const { error, errors, products, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.raw_products = products;
          this.total = total;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getCategories() {
      try {
        this.loading = true;

        const params = { active: this.active, type: "PRODUCT" };
        const response = await api.get("/rest-home/stock/items/categories", {
          params,
        });
        const { error, errors, stock_item_categories } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          for (let item of stock_item_categories) {
            item.name = `${item.name} (${item.stock_item_type_name})`;
          }

          this.stock_item_categories = stock_item_categories;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getUnitsOfMeasurement() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/stock/items/units-of-measurement"
        );
        const { error, errors, stock_item_units_of_measurement } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.stock_item_units_of_measurement =
            stock_item_units_of_measurement;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getProductUnitsOfMeasurement() {
      try {
        this.loading = true;

        const response = await api.get("/units-of-measurement/from-products");
        const { error, errors, units_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.units_of_measurement = units_of_measurement;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.products-inventory-modern {
  background: transparent;
}

/* Content Section */
.products-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Section */
.content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 24px;
}

.header-left {
  flex: 1;
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
}

.section-icon {
  color: #0f65b0;
  margin-right: 12px;
  font-size: 20px;
}

.section-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 14px;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

/* Filters Section */
.filters-section {
  margin-bottom: 8px;
}

.filters-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.filters-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.filters-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.filters-title i {
  color: #0f65b0;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  padding: 24px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.filter-icon {
  color: #6b7280;
  font-size: 14px;
}

.modern-input,
.modern-select {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-input:focus,
.modern-select:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

/* Table Section */
.table-section {
  margin-bottom: 24px;
}

.loading-overlay {
  border-radius: 16px;
  min-height: 300px;
}

.no-results {
  background: white;
  border-radius: 16px;
  padding: 60px 24px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.no-results-icon {
  font-size: 64px;
  color: #cbd5e1;
  margin-bottom: 20px;
}

.no-results-title {
  color: #1e293b;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.no-results-text {
  color: #64748b;
  font-size: 16px;
  margin: 0;
}

.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

/* Table Cell Styling */
.product-name-cell {
  padding: 8px 0;
}

.product-name {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
}

.category-cell {
  padding: 8px 0;
}

.category-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
  border: 1px solid #60a5fa;
}

.no-category {
  color: #6b7280;
  font-style: italic;
  font-size: 13px;
}

.actions-cell {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.btn-action-code {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 11px !important;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-action-code:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4) !important;
}

.btn-action-edit {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 11px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-action-edit:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.4) !important;
}

/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-wrapper {
  padding: 8px 0;
}

.modal-subtitle {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .content-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .header-actions {
    justify-content: center;
  }

  .filters-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .filters-card {
    border-radius: 12px;
  }

  .table-card {
    border-radius: 12px;
  }

  .filters-grid {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .section-title {
    font-size: 20px;
  }

  .actions-cell {
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }

  .btn-action-code,
  .btn-action-edit {
    width: 100% !important;
    justify-content: center !important;
  }

  .btn-add-modern {
    width: 100% !important;
    justify-content: center !important;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
  }

  .section-subtitle {
    font-size: 13px;
  }

  .filters-header {
    padding: 12px 16px;
  }

  .filters-title {
    font-size: 14px;
  }

  .btn-add-modern {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }
}

/* Override Vuetify styles */
.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}
</style>